import request from '@/config/axios'

/** 服务分类：bazi=命理排盘 feng=风水堪舆 qimen=奇门择吉 liuren=六壬占卜 */
export const SERVICE_CATEGORY_OPTIONS = [
  { label: '命理排盘', value: 'bazi' },
  { label: '风水堪舆', value: 'feng' },
  { label: '奇门择吉', value: 'qimen' },
  { label: '六壬占卜', value: 'liuren' }
]

export const SERVICE_CATEGORY_LABELS: Record<string, string> = {
  bazi: '命理排盘',
  feng: '风水堪舆',
  qimen: '奇门择吉',
  liuren: '六壬占卜'
}

export const SERVICE_CATALOG_STATUS_LABELS: Record<number, string> = {
  0: '上架',
  1: '下架'
}

/** 服务目录 VO（价格单位：分） */
export interface ServiceCatalogVo {
  id?: number
  name: string
  category: string
  intro?: string
  unit: string
  basePrice: number
  priceMin: number
  priceMax: number
  sort?: number
  status?: number
  createTime?: Date
}

/** 目录分页查询参数 */
export interface ServiceCatalogPageParams {
  pageNo?: number
  pageSize?: number
  name?: string
  status?: number
}

export const ServiceCatalogApi = {
  // 查询目录分页（名称关键字/状态筛选）
  getCatalogPage: (params: ServiceCatalogPageParams) => {
    return request.get({ url: '/xuanxue/service-catalog/page', params })
  },
  // 查询目录详情
  getCatalog: (id: number) => {
    return request.get({ url: '/xuanxue/service-catalog/get', params: { id } })
  },
  // 新建目录（区间校验 min ≤ 基准价 ≤ max 由后端兜底）
  createCatalog: (data: ServiceCatalogVo) => {
    return request.post({ url: '/xuanxue/service-catalog/create', data })
  },
  // 编辑目录（基准价/区间变更即时生效）
  updateCatalog: (data: ServiceCatalogVo) => {
    return request.put({ url: '/xuanxue/service-catalog/update', data })
  },
  // 目录上下架（下架后师傅端隐藏该项配置、用户端不展示）
  updateCatalogStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/service-catalog/update-status', params: { id, status } })
  },
  // 删除目录（有师傅配置引用时后端拒绝）
  deleteCatalog: (id: number) => {
    return request.delete({ url: '/xuanxue/service-catalog/delete', params: { id } })
  }
}
